import { DeleteCardProgress, VariantFormFieldKey } from '../types';

export const VariantFormFieldKeyToContentKeyMap: { [k in VariantFormFieldKey]: string } = {
  [VariantFormFieldKey.EMAIL_BODY]: '',
  [VariantFormFieldKey.EMAIL_FROM_NAME]: 'fromName',
  [VariantFormFieldKey.EMAIL_PRE_HEADER]: 'preheaderText',
  [VariantFormFieldKey.EMAIL_SENDERS_EMAIL]: 'fromEmail',
  [VariantFormFieldKey.EMAIL_SUBJECT_LINE]: 'subject',
  [VariantFormFieldKey.EMAIL_REPLY_TO_EMAIL]: 'replyTo',
  [VariantFormFieldKey.EVERYTHING]: '',
  [VariantFormFieldKey.PUSH_MESSAGE]: 'message',
  [VariantFormFieldKey.PUSH_TITLE]: 'title',
  [VariantFormFieldKey.SEND_TIME_DATE]: '',
  [VariantFormFieldKey.SEND_TIME_TIME]: '',
  [VariantFormFieldKey.SEND_TIME_VALIDATION_META_INFO]: '',
  [VariantFormFieldKey.SMS_IMAGE_URL]: 'imageUrl',
  [VariantFormFieldKey.SMS_MESSAGE]: 'message',
  [VariantFormFieldKey.STO]: '',
  [VariantFormFieldKey.WEB_PUSH_BODY]: 'message',
  [VariantFormFieldKey.WEB_PUSH_CLICK_LOCATION]: 'clickAction',
  [VariantFormFieldKey.WEB_PUSH_ICON]: 'icon',
  [VariantFormFieldKey.WEB_PUSH_TITLE]: 'title',
};

export const VariantFormFieldKeyToVariantInputKeyMap: { [k in VariantFormFieldKey]: string } = {
  [VariantFormFieldKey.EMAIL_BODY]: '',
  [VariantFormFieldKey.EMAIL_FROM_NAME]: 'fromName',
  [VariantFormFieldKey.EMAIL_PRE_HEADER]: 'preHeader',
  [VariantFormFieldKey.EMAIL_SENDERS_EMAIL]: 'senderEmail',
  [VariantFormFieldKey.EMAIL_SUBJECT_LINE]: 'subjectLine',
  [VariantFormFieldKey.EMAIL_REPLY_TO_EMAIL]: 'replyTo',
  [VariantFormFieldKey.EVERYTHING]: '',
  [VariantFormFieldKey.PUSH_MESSAGE]: 'message',
  [VariantFormFieldKey.PUSH_TITLE]: 'title',
  [VariantFormFieldKey.SEND_TIME_DATE]: 'sendTimeStartTime',
  [VariantFormFieldKey.SEND_TIME_TIME]: '',
  [VariantFormFieldKey.SEND_TIME_VALIDATION_META_INFO]: '',
  [VariantFormFieldKey.SMS_IMAGE_URL]: 'image',
  [VariantFormFieldKey.SMS_MESSAGE]: 'message',
  [VariantFormFieldKey.STO]: '',
  [VariantFormFieldKey.WEB_PUSH_BODY]: 'body',
  [VariantFormFieldKey.WEB_PUSH_CLICK_LOCATION]: 'clickAction',
  [VariantFormFieldKey.WEB_PUSH_ICON]: 'icon',
  [VariantFormFieldKey.WEB_PUSH_TITLE]: 'title',
};

export const deletingCardState = [DeleteCardProgress.DELETING, DeleteCardProgress.ENDED];
